<!--suppress ALL -->
<div class="jurisdiction-overview-container">
  <!-- <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
    <h2 class="jurisdiction-overview-heading">{{'overview.jurisdiction-overview.employee_access' | translate}}</h2>
  </div> -->
  <div class="overview-table-section">
    <div>
      <div class="overflow-tab-section">
        <div class="ui-inputgroup">
          <span class="ui-inputgroup-addon"><i class="pi pi-search search-icon"></i></span>
          <input
            (input)="jurisdictionOverview.filterGlobal($event.target.value, 'contains')"
            [(ngModel)]="globalFilterValue"
            pInputText
            placeholder="Search"
            size="25"
            type="text" />
        </div>
      </div>
      <h2 class="overview-table-section-heading">
        {{ 'overview.jurisdiction-overview.all_orders' | translate }}
        <button
          (click)="exportToCSV()"
          id="export-csv-button"
          label="{{ 'overview.jurisdiction-overview.export-csv-button' | translate }}"
          pButton
          type="button"></button>
        <button
          (click)="resetList()"
          id="reset-list-button"
          label="{{ 'overview.jurisdiction-overview.table-reset-button' | translate }}"
          pButton
          type="button"></button>
      </h2>
      <p-table
        #jurisdictionOverview
        [columns]="appColumns"
        [defaultSortOrder]="1"
        [filterDelay]="0"
        [globalFilterFields]="filterFields"
        [scrollable]="true"
        [sortOrder]="-1"
        [value]="allApplications"
        [rows]="tableConfig?.rowsPerPage"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="tableConfig?.rowsPerPageOptions"
        [paginator]="true"
        currentPageReportTemplate="{{ 'app.paginator-current-text.showing' | translate }} {first} - {last} {{
          'app.paginator-current-text.of' | translate
        }} {totalRecords} {{ 'app.paginator-current-text.entries' | translate }}"
        dataKey="application_id"
        sortField="application_id"
        styleClass="netz-table">
        <ng-template let-columns pTemplate="header">
          <tr>
            <th class="table-columns" pSortableColumn="application_id">
              {{ 'overview.jurisdiction-overview.application_id' | translate }}
              <p-sortIcon field="application_id"></p-sortIcon>
            </th>
            <th class="table-columns" pSortableColumn="connection_location">
              {{ 'overview.jurisdiction-overview.connection_location' | translate }}
              <p-sortIcon field="connection_location"></p-sortIcon>
            </th>

            <th class="table-columns" pSortableColumn="applicant">
              {{ 'overview.jurisdiction-overview.applicant' | translate }}
              <p-sortIcon field="applicant"></p-sortIcon>
            </th>

            <th *ngIf="!(hideTechnicianColumn && role === 'employee')" class="table-columns" pSortableColumn="technician">
              {{ 'overview.jurisdiction-overview.installer' | translate }}
              <p-sortIcon field="technician"></p-sortIcon>
            </th>
            <th *ngIf="showCompanyNameColumn && role === 'employee'" class="table-columns" pSortableColumn="company_name">
              {{ 'overview.jurisdiction-overview.company-name' | translate }}
              <p-sortIcon field="company_name"></p-sortIcon>
            </th>
            <th class="table-columns" pSortableColumn="sk_application_type_detail">
              {{ 'overview.jurisdiction-overview.sk_application_type_detail' | translate }}
              <p-sortIcon field="sk_application_type_detail"></p-sortIcon>
            </th>
            <th class="table-columns" pSortableColumn="branch">
              {{ 'overview.jurisdiction-overview.branch' | translate }}
              <p-sortIcon field="branch"></p-sortIcon>
            </th>
            <th class="table-columns" pSortableColumn="sk_orderprocess_status">
              {{ 'overview.jurisdiction-overview.process' | translate }}
              <p-sortIcon field="sk_orderprocess_status"></p-sortIcon>
            </th>
            <th class="table-columns" pSortableColumn="assigned_employee_id" *ngIf="showEmployeeColumn">
              {{ 'overview.jurisdiction-overview.assigned-employee' | translate }}
              <p-sortIcon field="assigned_employee_id"></p-sortIcon>
            </th>
            <th class="table-columns" pSortableColumn="last_changed">
              {{ 'overview.jurisdiction-overview.last_changed' | translate }}
              <p-sortIcon field="last_changed"></p-sortIcon>
            </th>
            <th class="table-columns" pSortableColumn="desired_date">
              {{ 'overview.jurisdiction-overview.desired_date' | translate }}
              <p-sortIcon field="desired_date"></p-sortIcon>
            </th>
            <th class="actions-column"></th>
          </tr>

          <tr *ngIf="showFilters">
            <th></th>
            <th></th>
            <th></th>
            <th *ngIf="!(hideTechnicianColumn && role === 'employee')"></th>
            <th *ngIf="showCompanyNameColumn && role === 'employee'"></th>
            <th>
              <p-multiSelect
                id="typeMultiSelectFilter"
                [options]="typeFilterOptions$ | async"
                [defaultLabel]="'Select'"
                [(ngModel)]="typeFilter"
                appendTo="body"
                [displaySelectedLabel]="false"
                tooltip="{{ typeFilterText }}"
                tooltipPosition="top"
                (onChange)="onFilterChange($event, 'sk_application_type_detail')"
                [filter]="true"
                styleClass="ui-column-filter"></p-multiSelect>
            </th>
            <th>
              <p-multiSelect
                id="branchMultiSelectFilter"
                [options]="branchFilterOptions$ | async"
                [defaultLabel]="'Select'"
                [(ngModel)]="branchFilter"
                appendTo="body"
                [displaySelectedLabel]="false"
                tooltip="{{ branchFilterText }}"
                tooltipPosition="top"
                (onChange)="onFilterChange($event, 'branch')"
                [filter]="true"
                styleClass="ui-column-filter"></p-multiSelect>
            </th>
            <th>
              <p-multiSelect
                id="processMultiSelectFilter"
                [options]="processFilterOptions$ | async"
                [defaultLabel]="'Select'"
                [(ngModel)]="processFilter"
                appendTo="body"
                [displaySelectedLabel]="false"
                tooltip="{{ processFilterText }}"
                tooltipPosition="top"
                (onChange)="onFilterChange($event, 'sk_orderprocess_status')"
                [filter]="true"
                styleClass="ui-column-filter"></p-multiSelect>
            </th>
            <th *ngIf="showEmployeeColumn">
              <p-multiSelect
                id="employeeFilter"
                [options]="employeesFilterOptions$ | async"
                [defaultLabel]="'Select'"
                [(ngModel)]="selectedEmployeeFilter"
                appendTo="body"
                (onChange)="onFilterChange($event, 'employee')"
                [filter]="true"
                styleClass="ui-column-filter"></p-multiSelect>
            </th>
            <th *ngIf="'app.calendar-settings' | translate as locale">
              <div class="date-filter-align">
                <p-calendar
                  tabIndex="0"
                  appCalendarEscapeClose
                  id="lastChangedDateFilter"
                  appendTo="body"
                  placeholder="Select"
                  styleClass="ui-column-filter"
                  yearRange="2020:2050"
                  dateFormat="yy-mm-dd"
                  [(ngModel)]="selectedLastChangedDate"
                  (onSelect)="onFilterChange($event, 'last_changed')"
                  [readonlyInput]="true"
                  [locale]="locale"
                  [monthNavigator]="true"
                  [yearNavigator]="true"></p-calendar>
                <p-menu #menuLastChanged appendTo="body" [popup]="true" [model]="lastChangedDateFilterOptions"></p-menu>
                <button type="button" pButton icon="pi pi-filter" (click)="menuLastChanged.toggle($event)"></button>
              </div>
            </th>
            <th *ngIf="'app.calendar-settings' | translate as locale">
              <div class="date-filter-align">
                <p-calendar
                  tabIndex="0"
                  appCalendarEscapeClose
                  id="desiredDateFilter"
                  appendTo="body"
                  placeholder="Select"
                  styleClass="ui-column-filter"
                  yearRange="2020:2050"
                  dateFormat="yy-mm-dd"
                  [(ngModel)]="selectedDesiredDate"
                  (onSelect)="onFilterChange($event, 'desired_date')"
                  [readonlyInput]="true"
                  [locale]="locale"
                  [monthNavigator]="true"
                  [yearNavigator]="true"></p-calendar>
                <p-menu #menuDesiredDate appendTo="body" [popup]="true" [model]="desiredDateFilterOptions"></p-menu>
                <button type="button" pButton icon="pi pi-filter" (click)="menuDesiredDate.toggle($event)"></button>
              </div>
            </th>
            <th></th>
          </tr>
        </ng-template>

        <ng-template let-columns="columns" let-item let-rowIndex="rowIndex" pTemplate="body">
          <tr [class.highlight-row]="highlightedRowIndex === item.application_id">
            <td class="table-columns">
              {{ item.application_ext_id ? item.application_ext_id : item.application_id ? item.application_id : '-' }}
            </td>
            <td class="table-columns">
              <div class="location-cell">
                {{
                  item.grid_comp_area != null
                    ? (item.grid_comp_area | areaFieldFieldSector : item.grid_comp_field : item.grid_comp_field_sector)
                    : item.connection_location
                    ? (item.connection_location | connectionLocationFormat | addDistrict : item.district : item.sk_application_type)
                    : '-'
                }}
                <span
                  (click)="filterList(item.grid_comp_area != null ? item.grid_comp_area : item.connection_location)"
                  *ngIf="showFilterByLocationIcon"
                  class="pointer-cursor filter-icon">
                  <i
                    class="pi pi-filter"
                    id="filter-list-{{ rowIndex }}"
                    pTooltip="{{ 'overview.jurisdiction-overview.filter-by-location' | translate }}"></i>
                </span>
              </div>
            </td>
            <td class="table-columns">{{ item.applicant ? item.applicant : '-' }}</td>
            <td *ngIf="!(hideTechnicianColumn && role === 'employee')" class="table-columns">
              {{ item.technician_id || (showTechnicianColumn && item.technician) ? item.technician : '-' }}
            </td>
            <td *ngIf="showCompanyNameColumn && role === 'employee'" class="table-columns">
              {{ item.company_name ? item.company_name : '-' }}
            </td>
            <td class="table-columns">
              {{
                item[applicationTypeDetailsKey]
                  ? ('lookup.' + applicationTypeDetailsKey + '.options.' + item[applicationTypeDetailsKey] + '.name' | translate)
                  : '-'
              }}
            </td>
            <td class="table-columns">
              <span *ngFor="let object of item.branch">
                {{ 'overview.details-data.data-rows.' + object | translate }}
                <br />
              </span>
              <span *ngIf="item[applicationTypeDetailsKey] === 'installation_gridcomp'">
                {{ 'overview.details-data.data-rows.power' | translate }}
              </span>
              <span
                *ngIf="
                  !item.branch.length &&
                  item[applicationTypeDetailsKey] !== 'installation_gridcomp' &&
                  item[applicationTypeDetailsKey] !== 'gridcomp_feedin_gridcomp'
                ">
                -
              </span>
            </td>
            <td class="table-columns">
              <span class="table-columns">
                {{
                  item[orderProcessesKey]
                    ? ('lookup.' + orderProcessesKey + '.options.' + item[orderProcessesKey] + '.name' | translate)
                    : '-'
                }}
              </span>
            </td>
            <td class="table-columns" *ngIf="role === 'administrator' || role === 'employee'">
              <p-dropdown
                [options]="employeesListData"
                [(ngModel)]="item.employee"
                optionLabel="label"
                appendTo="body"
                (onChange)="onSelectEmployee($event.value, item.application_id)"></p-dropdown>
            </td>
            <td class="table-columns">{{ item.last_changed ? (item.last_changed | stringifiedDate) : '-' }}</td>
            <td class="table-columns">{{ item.desired_date ? item.desired_date : '-' }}</td>
            <td class="actions-column icon-cells">
              <div class="icons-section">
                <!-- <span (click)="viewApplication(item, true)" class="pointer-cursor">
                  <i class="pi pi-eye"
                     id="app-icon-view-{{rowIndex}}"
                     pTooltip="{{'overview.jurisdiction-overview.view_application' | translate}}"></i>
                </span> -->
                <!-- <span (click)="viewApplication(item, false)"
                      *ngIf="!isArchiveView" class="pointer-cursor">
                  <i *ngIf="evaluateActionButtonState(item)"
                       class="pi pi-check"
                       id="app-icon-details-{{rowIndex}}"
                       pTooltip="{{'lookup.' + executorActionsKey + '.options.' + item[executorActionsKey] + '.name' | translate}}"></i>
                    <label *ngIf="!evaluateActionButtonState(item)" class="no-icon"> - </label>
                </span> -->
                <!-- <span (click)="sendMessage(item)" *ngIf="!isArchiveView" class="pointer-cursor">
                  <i class="pi pi-envelope"></i>
                </span> -->
                <button
                  (click)="viewApplication(item)"
                  label="{{ 'view-button-label' | translate }}"
                  pButton
                  type="button"
                  tabindex="0"
                  appEnterClick></button>
                <span
                  (click)="updateProcessingStatus(item)"
                  *ngIf="(role === 'administrator' || role === 'employee') && !isArchiveView"
                  class="pointer-cursor"
                  [class.disabled]="technicianId !== item.assigned_employee_id">
                  <i
                    [ngClass]="item.locked === '0' ? 'pi pi-unlock unlock-icon-style' : 'pi pi-lock lock-icon-style'"
                    pTooltip="{{ 'overview.jurisdiction-overview.processing-status' | translate }}"></i>
                </span>
                <span
                  (click)="confirmApplicationArchive(item.application_id)"
                  *ngIf="(role === 'administrator' || role === 'employee') && !isArchiveView"
                  class="pointer-cursor">
                  <i class="pi pi-arrow-circle-right" pTooltip="{{ 'overview.jurisdiction-overview.archive' | translate }}"></i>
                </span>
                <span
                  (click)="confirmApplicationArchive(item.application_id)"
                  *ngIf="isArchiveView && role !== 'observer'"
                  class="pointer-cursor">
                  <i class="pi pi-backward unarchive-icon" pTooltip="{{ 'overview.jurisdiction-overview.unarchive' | translate }}"></i>
                </span>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr *ngIf="isZeroApplication">
            <td>
              {{ 'overview.no-data-available' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog
  #archiveConfirmDialog
  icon="pi pi-info-circle"
  message="{{
    isArchiveView
      ? ('overview.jurisdiction-overview.unarchive-confirmation-text' | translate)
      : ('overview.jurisdiction-overview.archive-confirmation-text' | translate)
  }}"
  styleClass="netz-confirm-dialog">
  <p-footer>
    <button (click)="archiveConfirmDialog.accept()" label="{{ 'yes-button-label' | translate }}" pButton type="button"></button>
    <button (click)="archiveConfirmDialog.reject()" label="{{ 'no-button-label' | translate }}" pButton type="button"></button>
  </p-footer>
</p-confirmDialog>

<app-loader *ngIf="isLoading"></app-loader>
